import { render, staticRenderFns } from "./adult-stock-list.vue?vue&type=template&id=2af4d1c4&"
import script from "./adult-stock-list.vue?vue&type=script&lang=js&"
export * from "./adult-stock-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports